/**
 * plugins/index.js
 *
 * Automatically included in `./src/main.js`
 */

import i18n from '@/plugins/vue-i18n';
import router from '@/router';
import pinia from '@/stores';
import { plugin as InputFacade } from 'vue-input-facade';
import confirm from './confirm-dialog/plugin';
import vuetify from './vuetify';

export function registerPlugins(app) {
  app
    .use(vuetify)
    .use(router)
    .use(pinia)
    .use(i18n)
    .use(confirm)
    .use(InputFacade, {
      name: 'mask',
      tokens: {
        '#': { pattern: /\d/ },
        a: { pattern: /[a-z]/i },
        A: { pattern: /[a-z]/i, transform: (v) => v.toLocaleUpperCase() },
        N: { pattern: /[0-9a-z]/i },
        X: { pattern: /[0-9a-z]/i, transform: (v) => v.toLocaleUpperCase() },
      },
    });
}
